import { Component, Input } from '@angular/core';
import ILicencia from '@models/licencia.interface';
import { SessionService } from '@services/session.service';
import Roles from '@shared/enums/roles.enum';

@Component({
  selector: 'app-header-licencia',
  templateUrl: './header-licencia.component.html',
  styleUrls: ['./header-licencia.component.scss']
})
export class HeaderLicenciaComponent {

  constructor(protected sessionService: SessionService) {}
  @Input() Licencia: ILicencia;

  get isProveedor(): boolean {
    return this.sessionService.rolActual === Roles.prestador;
  }
}
